// Cafe 110 Business Data - Updated per owner's requests
export const cafeData = {
  name: "Cafe 110",
  tagline: "Authentic Italian café in South Wimbledon",
  description: "A family-run Italian café bringing authentic Calabrian flavours and community warmth to Wimbledon since October 2022.",
  logo: "/images/cafe-110-logo.png",
  
  address: {
    street: "110 Haydons Road",
    area: "Wimbledon",
    postcode: "SW19 1AW",
    city: "London",
    country: "United Kingdom",
    full: "110 Haydons Road, Wimbledon, London SW19 1AW"
  },
  
  coordinates: {
    lat: 51.4203119,
    lng: -0.1872348
  },
  
  hours: [
    { day: "Sunday", open: "9:00 AM", close: "4:00 PM" },
    { day: "Monday", open: "7:00 AM", close: "5:00 PM" },
    { day: "Tuesday", open: "7:00 AM", close: "5:00 PM" },
    { day: "Wednesday", open: "7:00 AM", close: "5:00 PM" },
    { day: "Thursday", open: "7:00 AM", close: "5:00 PM" },
    { day: "Friday", open: "7:00 AM", close: "5:00 PM" },
    { day: "Saturday", open: "8:00 AM", close: "5:00 PM" }
  ],
  
  hygiene: {
    rating: 5,
    maxRating: 5,
    inspectionDate: "14 October 2024",
    authority: "Merton",
    details: {
      foodHandling: "Very Good",
      cleanliness: "Very Good",
      management: "Good"
    }
  },
  
  cuisine: ["Italian", "Café", "Coffee & Tea", "Breakfast and Brunch"],
  priceRange: "$",
  
  nearestStation: "South Wimbledon",
  distanceFromStation: "695 yards",
  
  googleMapsUrl: "https://www.google.com/maps/dir/?api=1&destination=51.4203119,-0.1872348",
  
  reviews: {
    averageRating: 4.8,
    totalReviews: 127,
    highlights: [
      {
        quote: "Best coffee in Wimbledon! Francesco makes you feel like family. The croissants are fresh and flaky, exactly like in Italy.",
        author: "Sarah M.",
        rating: 5,
        date: "November 2024"
      },
      {
        quote: "A hidden gem. The homemade pasta is incredible - try the carbonara. Authentic Italian flavours at reasonable prices.",
        author: "James T.",
        rating: 5,
        date: "October 2024"
      },
      {
        quote: "My go-to spot for breakfast. The paninis are generously filled and the staff are always welcoming. Highly recommend!",
        author: "Emma R.",
        rating: 5,
        date: "September 2024"
      },
      {
        quote: "Fantastic little café with genuine Italian charm. The focaccia is incredible - crispy and quality toppings.",
        author: "Michael P.",
        rating: 4,
        date: "August 2024"
      },
      {
        quote: "Love this place! Perfect for a quiet coffee or a proper Italian lunch. The cannoli are to die for.",
        author: "Lucy K.",
        rating: 5,
        date: "July 2024"
      }
    ]
  },
  
  about: {
    paragraphs: [
      "There has been a café at 110 Haydons Road for a very long time. Back in 1910, this was home to the Devonshire Dining Rooms. More than a century later, in October 2022, my parents opened Cafe 110.",
      "Our family is from Calabria, and we also spent part of our lives living in Italy. One of the things we miss most about Italy, and something that is such a big part of Calabrian culture, is sitting down together as a family, taking your time and eating great food. Of course, it is about the food, but just as much about the people around the table, the conversations and the time spent together.",
      "When we came to Wimbledon, we wanted to bring a little piece of that feeling with us. Cafe 110 became our way of doing that, bringing the authentic flavours, food and coffee we grew up with to our little corner of Wimbledon.",
      "From the beginning, it has been a family-run café. We wanted it to feel personal, welcoming and familiar. A place where you can come in for a good coffee and a fresh panino, meet a friend, have a chat and feel at home.",
      "And over the years, that is exactly what it has become.",
      "Our customers have become a huge part of our story. Some come in every day for their morning coffee, others come every week to meet friends, catch up over breakfast or lunch, or simply see a familiar face. We have watched families grow, including children who first came through our doors when we opened and who we have now watched grow up.",
      "For us, that is what a café should be. Somewhere that becomes part of your everyday life, where you can meet a friend, catch up over a coffee and feel part of the community.",
      "We are especially proud when customers tell us that Cafe 110 reminds them of Italy. Some have lived there themselves and say that our coffee or food brings back memories of home, while others tell us that visiting feels like being back on holiday. We try to keep that feeling in everything we do, using the authentic flavours we grew up with and keeping our food fresh, simple and full of flavour.",
      "We also have our little deli corner, because we wanted that feeling to travel beyond the café. It is a little collection of the tastes and treats we love, so you can take a piece of Italy home with you, bring it into your own kitchen, share it around your table or give it as a gift to someone you love.",
      "The lovely messages and reviews we receive from our customers mean a lot to my family. Hearing that people feel welcomed, love the food, or have made Cafe 110 part of their routine is what makes all the early mornings and long days worthwhile.",
      "From our home in Italy to our home in Wimbledon, we want to say grazie mille for being part of the Cafe 110 family!"
    ]
  },
  
  featuredDishes: [
    {
      name: "Carbonara",
      description: "Handcrafted pasta with Parmesan, Roman Pecorino and Pancetta",
      price: "£7.50",
      category: "Pasta",
      image: "/images/menu/pasta-carbonara.jpg",
      alt: "Traditional carbonara with Parmesan, Pecorino and crispy pancetta"
    },
    {
      name: "Focaccia Baresana",
      description: "Italian spiced salami, tomato, mozzarella, lettuce",
      price: "£9.50",
      category: "Special Paninis",
      image: "/images/menu/focaccia-baresana.jpg",
      alt: "Focaccia Baresana with spiced salami, fresh tomato and melted mozzarella"
    },
    {
      name: "Lasagna Bolognese",
      description: "Classic lasagna with layers of pasta, rich beef ragù, and creamy béchamel",
      price: "£9.00",
      category: "Lunches",
      image: "/images/menu/lasagna-bolognese.jpg",
      alt: "Traditional layered lasagna bolognese with beef ragù and creamy béchamel"
    },
    {
      name: "Arancini",
      description: "Crispy rice balls with Ham and Cheese, Aubergine, or Bolognese",
      price: "£4.50",
      category: "Savouries",
      image: "/images/menu/arancini-rice-balls.jpg",
      alt: "Golden fried arancini rice balls with various fillings"
    }
  ]
};
